import {motion} from "framer-motion";
import {FC} from "react";
import {CustomPageHeader} from "../CustomPageHeader.tsx";
import {FieldGroup} from "../../ui-components/fieldset.tsx";
import {CustomSelect} from "../CustomSelect.tsx";
import {subscribersArr} from "../../constants/constants.ts";
import {TextFieldCustom} from "../TextFieldCustom.tsx";
import {ButtonsBottomBlockOfPage} from "../ButtonsBottomBlockOfPage.tsx";
import {Button} from "../../ui-components/button.tsx";
import {IsLoadingContainer} from "../../container/IsLoadingContainer.tsx";
import {FormikProvider} from "formik";
import {MultipleSelect} from "../MultipleSlectCustom.tsx";
import {ModalType} from "../../context/ModalContext.tsx";
import useSearchChannelPage from "../../hooks/channel/useSearchChannels.ts";
import {languages} from "../../dateUtils/dateUtils.ts";
import {useCountriesArr} from "../../hooks/useCountriesSelectOptions.ts";

interface ModalProps {
    onClose: (type?: ModalType) => void;
    searchType: "allChannels" | "createCampaign"
    modalId: string
}

export const SearchChannelsModal: FC<ModalProps> = ({searchType, modalId}) => {
    const {
        isLoading,
        formik,
        resetForm,
        handleBackClick,
        closeManually,
        categoriesData, t
    } = useSearchChannelPage({searchType, modalId});
    const countries = useCountriesArr();
    return (
        <div
            className="absolute inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={handleBackClick}
        >
            <motion.div
                className="w-full h-full bg-[var(--default-page-color)] flex flex-col"
                initial={{y: 50, opacity: 0, scale: 0.8}}
                animate={{y: 0, opacity: 1, scale: 1}}
                exit={{y: 50, opacity: 0, scale: 0.8}}
                transition={{duration: 0.3, ease: "easeInOut"}}
                onClick={(e) => e.stopPropagation()} // Остановить всплытие
            >
                <CustomPageHeader title={t('modals.searchChannels.heading')} type={"BACK"} onClickBack={closeManually} padding_xs={true}/>
                <div className="px-4 overflow-auto h-full max-h-custom custom-scrollBar py-6">
                    <IsLoadingContainer isLoading={isLoading}>
                        {
                            categoriesData
                                ?
                                <FormikProvider value={formik}>
                                    <form className={"w-full  flex flex-col justify-between"}
                                          onSubmit={formik.handleSubmit}>
                                        <div>
                                            <section className={"flex flex-col gap-y-[10px] mb-[30px]"}>
                                                <FieldGroup className={"flex flex-col w-full h-full gap-y-6"}>
                                                    <div className={"mb-0"}>
                                                        <TextFieldCustom getFieldProps={formik.getFieldProps}
                                                                         formikValue={'query'}
                                                                         text={t('form.textFields.searchChannel.subTitle')}
                                                                         label={t('form.textFields.searchChannel.title')}
                                                                         search
                                                                         placeholder={t('form.textFields.searchChannel.placeholder')}/>
                                                    </div>
                                                    <div className={"mb-0"}>
                                                        <CustomSelect getFieldProps={formik.getFieldProps}
                                                                      formikValue="countries"
                                                                      title={t('form.selects.country.title')}
                                                                      arr={countries}
                                                                      existNotChoosen={true}
                                                                      existLabel={true}/>
                                                    </div>
                                                    <div className={"mb-0"}>
                                                        <CustomSelect getFieldProps={formik.getFieldProps}
                                                                      formikValue="languages"
                                                                      title={t('form.selects.language.title')}
                                                                      arr={languages}
                                                                      existNotChoosen={true}
                                                                      existLabel={true}/>
                                                    </div>
                                                    <div className={"mb-0"}>
                                                        <MultipleSelect title={t('form.selects.category.title')}
                                                                        existLabel={true}
                                                                        multiple={true}
                                                                        formikValue={'categories'}
                                                                        arr={categoriesData}/>
                                                    </div>
                                                    <div className={"mb-0"}>
                                                        <CustomSelect getFieldProps={formik.getFieldProps}
                                                                      formikValue="subscribers"
                                                                      title={t('form.selects.subscribersCount.title')}
                                                                      arr={subscribersArr}
                                                                      existNotChoosen={true}
                                                                      existLabel={true}
                                                        />
                                                    </div>
                                                </FieldGroup>
                                            </section>
                                        </div>
                                        <div
                                            className={"w-full fixed bottom-[80px] px-4 left-0 bg-[var(--default-page-color)] pt-4"}>
                                            <Button color={'light'}
                                                    onClick={resetForm}
                                                    className={"w-full !py-2.5 !text-sm !font-semibold border !border-[var(--border-color-block)] bg-transparent before:bg-transparent shadow-xs"}>
                                                {t('common.buttons.resetAll')}
                                            </Button>
                                        </div>
                                        <ButtonsBottomBlockOfPage title1={t('common.buttons.cancel')} title2={t('common.buttons.searchChannelsBtn')}
                                                                  onClickBack={closeManually}
                                                                  continueFunc={formik.handleSubmit}/>
                                    </form>
                                </FormikProvider>
                                : ''
                        }
                    </IsLoadingContainer>
                </div>
            </motion.div>
        </div>
    );
};